import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'
import { isOrderPath } from '../order/RouteConstants'

// useHasStickyHeader determines whether this page should be using sticky headers.
export const useHasStickyHeader = () => {
  const isPortal = useIsPortal()
  const { pathname: url } = useLocation()
  const hasStickyHeader = isPortal && !!isOrderPath(url)
  const breadCrumbHeight = 44
  return useMemo(
    () => ({
      hasStickyHeader,
      breadCrumbHeight
    }),
    [hasStickyHeader, breadCrumbHeight]
  )
}
